import { z } from 'zod';
import { componentTypeSchema } from './component-base.schemas';
import { componentSchema } from './component-union.schemas';

// Library Component schemas
export const libraryComponentSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  siteId: z.string().uuid().nullable(),
  name: z.string().min(1, 'Component name is required'),
  description: z.string().optional(),
  type: componentTypeSchema,
  tags: z.string().optional(),
  isPublic: z.boolean().default(false),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  preview: componentSchema.optional(), // The actual component data for preview
});

export const createSharedComponentSchema = z.object({
  componentId: z.string().uuid(),
  siteId: z.string().uuid().optional(),
  name: z.string().min(1, 'Component name is required'),
  description: z.string().optional(),
  tags: z.string().optional(),
  isPublic: z.boolean().default(false),
});

export const updateSharedComponentSchema = z.object({
  name: z.string().min(1, 'Component name is required').optional(),
  description: z.string().optional(),
  tags: z.string().optional(),
  isPublic: z.boolean().optional(),
});

export const searchSharedComponentsSchema = z.object({
  type: componentTypeSchema.optional(),
  search: z.string().optional(),
  tags: z.string().optional(),
  siteId: z.string().uuid().optional(),
  includePublic: z.boolean().optional().default(true),
});

export const addFromLibrarySchema = z.object({
  libraryComponentId: z.string().uuid(),
  position: z.number().int().min(0).optional(),
});

// API Response schemas for library
export const libraryBrowseResponseSchema = z.object({
  components: z.array(libraryComponentSchema),
  total: z.number().int().min(0),
});

export const addFromLibraryResponseSchema = z.object({
  message: z.string(),
  component: componentSchema,
  totalComponents: z.number().int().min(0),
  sourceLibraryComponent: z.object({
    id: z.string().uuid(),
    name: z.string(),
    type: componentTypeSchema,
  }),
});

// Type exports
export type LibraryComponent = z.infer<typeof libraryComponentSchema>;
export type CreateSharedComponentRequest = z.infer<typeof createSharedComponentSchema>;
export type UpdateSharedComponentRequest = z.infer<typeof updateSharedComponentSchema>;
export type SearchSharedComponentsRequest = z.infer<typeof searchSharedComponentsSchema>;
export type AddFromLibraryRequest = z.infer<typeof addFromLibrarySchema>;
export type LibraryBrowseResponse = z.infer<typeof libraryBrowseResponseSchema>;
export type AddFromLibraryResponse = z.infer<typeof addFromLibraryResponseSchema>;
